import { type LoaderFunctionArgs, redirect } from 'react-router';
import { generateUserInfoByCodeQueryOptions } from '@/hooks/scan-code/use-user-info-by-code';
import { generateFriendInfoQueryOptions } from '@/hooks/users/use-friend-info';
import { ResponseError } from '@/models/response';
import ROUTES from '@/routes';
import { getUserId } from '@/stores/auth';
import { addToast } from '@/stores/toast';
import { catchFetcherError } from '@/utils/fetcher';
import { parseUrl } from '@/utils/parse-url';
import { queryClient } from '@/utils/query-client';

export async function contactRequestUserLoader({ request }: LoaderFunctionArgs) {
  const url = parseUrl(request.url);

  if (!url) return redirect(ROUTES.MESSAGES.$path());

  const { id, code } = ROUTES.CONTACT.REQUEST.USER.$deserializeSearchParams(url.searchParams);
  const userId = getUserId();

  if (code) {
    const userInfo = await queryClient
      .ensureQueryData(generateUserInfoByCodeQueryOptions(code))
      .catch(catchFetcherError);

    if (userInfo) {
      if (userInfo.Data?.UID === userId) {
        return redirect(ROUTES.MY.INFO.$path());
      }

      return {
        userInfo,
      };
    }
  }

  const friendInfo = await queryClient.ensureQueryData(generateFriendInfoQueryOptions(id)).catch((err) => {
    if (err instanceof ResponseError) {
      addToast({
        type: 'error',
        message: err.message,
      });
    }
  });

  if (id === userId) {
    return redirect(ROUTES.MY.INFO.$path());
  }
  if (!friendInfo) {
    return redirect(ROUTES.CONTACT.$path());
  }
  if (friendInfo.IsFriend && friendInfo.FriendInfo.FriendID) {
    return redirect(
      ROUTES.CONTACT.USERS.BY_ID.$buildPath({
        params: {
          userId: friendInfo.FriendInfo.FriendID,
        },
      }),
    );
  }

  return {
    friendInfo,
  };
}
